import MomentUtils from '@date-io/moment';
import HoustonThemeProvider from '@eduzz/houston-ui/ThemeProvider/deprecated/MuiV4Compat';
import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import FormFieldsContext from '@react-form-fields/material-ui/components/Context';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import Alert from 'components/Alert';
import { theme } from 'components/Theme';
import fieldConfig from 'config/fieldConfig';
import * as React from 'react';
import { IntlProvider } from 'react-intl';
import { ToastContainer } from 'react-toastify';
import Toast from 'v2/components/Shared/Toast';

const intlFormats = {
  number: {
    BRL: {
      style: 'currency',
      currency: 'BRL',
    },
    USD: {
      style: 'currency',
      currency: 'USD',
    },
  },
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

type AppProvidersProps = {
  children: React.ReactNode;
};

function AppProviders({ children }: AppProvidersProps) {
  return (
    <QueryClientProvider client={queryClient}>
      <IntlProvider locale='pt-BR' formats={intlFormats} defaultFormats={intlFormats}>
        <HoustonThemeProvider disabledFontBase>
          <MuiThemeProvider theme={theme}>
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <FormFieldsContext config={fieldConfig}>
                <Toast.Global />
                <Alert.Global />
                {children}
                <ToastContainer theme='colored' style={{ width: 'auto' }} />
                <CssBaseline />
                <ReactQueryDevtools position='bottom-right' />
              </FormFieldsContext>
            </MuiPickersUtilsProvider>
          </MuiThemeProvider>
        </HoustonThemeProvider>
      </IntlProvider>
    </QueryClientProvider>
  );
}

export { AppProviders };
